import { createAction } from 'redux-actions';

export const setSchoolApplications = createAction('SET_SCHOOL_APPLICATIONS');
export const setSchoolAttendanceAttended = createAction('SET_SCHOOL_ATTENDANCE_ATTENDED');

export const SAGA_TOGGLE_SCHOOL_ATTENDANCE_ATTENDED = 'SAGA_TOGGLE_SCHOOL_ATTENDANCE_ATTENDED';
export const SAGA_SAVE_PROGRESS_COMMENT = 'SAGA_SAVE_PROGRESS_COMMENT';
